module.exports = __webpack_public_path__ + "img/CompletedAnimation.2d3dcd95.gif";